import React, { useState } from "react";

const AddRenewableAgency = () => {
  const [formData, setFormData] = useState({
    renew_agency_name: "",
    renew_agency_address: "",
    renew_agency_city: "",
    renew_agency_district: "",
    renew_agency_state: "",
    renew_agency_pincode: "",
    renew_agency_phone: "",
    renew_agency_email: "",
  });

  const [errors, setErrors] = useState({});
  const [submissionStatus, setSubmissionStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const tempErrors = {};
    if (!formData.renew_agency_name) tempErrors.renew_agency_name = "Agency name is required.";
    if (!formData.renew_agency_address) tempErrors.renew_agency_address = "Address is required.";
    if (!formData.renew_agency_city) tempErrors.renew_agency_city = "City is required.";
    if (!formData.renew_agency_district) tempErrors.renew_agency_district = "District is required.";
    if (!formData.renew_agency_state) tempErrors.renew_agency_state = "State is required.";
    if (!formData.renew_agency_pincode) tempErrors.renew_agency_pincode = "Pincode is required.";
    if (!formData.renew_agency_email) tempErrors.renew_agency_email = "Email is required.";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const response = await fetch("https://backend-zkgn.onrender.com/api/renewable-agencies", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmissionStatus("Agency added successfully!");
        setFormData({
          renew_agency_name: "",
          renew_agency_address: "",
          renew_agency_city: "",
          renew_agency_district: "",
          renew_agency_state: "",
          renew_agency_pincode: "",
          renew_agency_phone: "",
          renew_agency_email: "",
        });
        setErrors({});
      } else {
        setSubmissionStatus("Failed to add agency.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setSubmissionStatus("An error occurred while submitting the form.");
    }
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Add Renewable Agency</h3>
      {submissionStatus && <div className="alert alert-info">{submissionStatus}</div>}

      <form onSubmit={handleSubmit}>
        <div className="row g-3">
          {/* Agency Name */}
          <div className="col-12">
            <label className="form-label">Agency Name</label>
            <input
              type="text"
              className="form-control"
              name="renew_agency_name"
              value={formData.renew_agency_name}
              onChange={handleChange}
            />
            {errors.renew_agency_name && <div className="text-danger">{errors.renew_agency_name}</div>}
          </div>

          {/* Address */}
          <div className="col-12">
            <label className="form-label">Address</label>
            <textarea
              className="form-control"
              name="renew_agency_address"
              rows="2"
              value={formData.renew_agency_address}
              onChange={handleChange}
            ></textarea>
            {errors.renew_agency_address && <div className="text-danger">{errors.renew_agency_address}</div>}
          </div>

          {/* City & District */}
          <div className="col-md-6">
            <label className="form-label">City</label>
            <input
              type="text"
              className="form-control"
              name="renew_agency_city"
              value={formData.renew_agency_city}
              onChange={handleChange}
            />
            {errors.renew_agency_city && <div className="text-danger">{errors.renew_agency_city}</div>}
          </div>

          <div className="col-md-6">
            <label className="form-label">District</label>
            <input
              type="text"
              className="form-control"
              name="renew_agency_district"
              value={formData.renew_agency_district}
              onChange={handleChange}
            />
            {errors.renew_agency_district && <div className="text-danger">{errors.renew_agency_district}</div>}
          </div>

          {/* State & Pincode */}
          <div className="col-md-6">
            <label className="form-label">State</label>
            <input
              type="text"
              className="form-control"
              name="renew_agency_state"
              value={formData.renew_agency_state}
              onChange={handleChange}
            />
            {errors.renew_agency_state && <div className="text-danger">{errors.renew_agency_state}</div>}
          </div>

          <div className="col-md-6">
            <label className="form-label">Pincode</label>
            <input
              type="text"
              className="form-control"
              name="renew_agency_pincode"
              value={formData.renew_agency_pincode}
              onChange={handleChange}
            />
            {errors.renew_agency_pincode && <div className="text-danger">{errors.renew_agency_pincode}</div>}
          </div>

          {/* Phone & Email */}
          <div className="col-md-6">
            <label className="form-label">Phone Number</label>
            <input
              type="text"
              className="form-control"
              name="renew_agency_phone"
              value={formData.renew_agency_phone}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              name="renew_agency_email"
              value={formData.renew_agency_email}
              onChange={handleChange}
            />
            {errors.renew_agency_email && <div className="text-danger">{errors.renew_agency_email}</div>}
          </div>
        </div>

        {/* Submit */}
        <div className="mt-4">
          <button type="submit" className="btn btn-primary">Submit</button>
        </div>
      </form>
    </div>
  );
};

export default AddRenewableAgency;
